import Vue from "vue";
import VueRouter from "vue-router";
import Start from "../views/Start.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "start",
    component: Start
  },
  {
    path: "/elpris",
    name: "elpris",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "elpris" */ "../views/Elpris.vue")
  },
  {
    path: "/uppgifter",
    name: "uppgifter",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "uppgifter" */ "../views/Uppgifter.vue")
  },
  {
    path: "/uppgifter2",
    name: "uppgifter2",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "uppgifter2" */ "../views/Uppgifter2.vue")
  },
  {
    path: "/bekrafta",
    name: "bekrafta",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "bekrafta" */ "../views/Bekrafta.vue")
  },
];

const router = new VueRouter({
  routes
});

export default router;
